// Leaf module — defines the shared list of optional Leads-spreadsheet
// columns. Lives on its own (no React, no page imports) so admin and
// settings surfaces can import it without dragging the entire Settings
// page module into their bundle chunk. Importing a 1500-line page
// indirectly was triggering a TDZ ("Cannot access 'H' before
// initialization") in the minified production bundle.
//
// Keep keys in sync with getColumns() in
// client/src/components/spreadsheet/leads-spreadsheet.tsx.
// `leadName` is intentionally omitted — the account name column is
// always required.
export const LEAD_COLUMN_OPTIONS: { key: string; label: string }[] = [
  { key: "starred", label: "Starred" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "emailAddress", label: "Email Address" },
  { key: "contactName", label: "Contact Name" },
  { key: "lastContacted", label: "Last Contacted" },
  { key: "notes", label: "Notes" },
  { key: "rating", label: "Rating" },
  { key: "address", label: "Address" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zipCode", label: "Zip" },
  { key: "clientType", label: "Client Type" },
  { key: "regionId", label: "Region" },
  { key: "talentId", label: "Talent" },
  { key: "rep", label: "Rep" },
  { key: "emailOptedOut", label: "Opt Out" },
];
